module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "time-usage-skills"
  }, [_c('div', {
    staticClass: "employee-switcher"
  }, [_c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.employeeWorkingFieldName === ''
    },
    on: {
      "click": function($event) {
        _vm.employeeWorkingFieldName = ''
      }
    }
  }, [_vm._v("\n            Alle medarbejdere\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.employeeWorkingFieldName === 'Svend, funktionær'
    },
    on: {
      "click": function($event) {
        _vm.employeeWorkingFieldName = 'Svend, funktionær'
      }
    }
  }, [_vm._v("\n            Svende, funktionær\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.employeeWorkingFieldName === 'Svend, timelønnet'
    },
    on: {
      "click": function($event) {
        _vm.employeeWorkingFieldName = 'Svend, timelønnet'
      }
    }
  }, [_vm._v("\n            Svende, timelønnet\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.employeeWorkingFieldName === 'Lærling'
    },
    on: {
      "click": function($event) {
        _vm.employeeWorkingFieldName = 'Lærling'
      }
    }
  }, [_vm._v("\n            Lærlinge\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8"
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "employees.timeUsageSkills"
    }
  }), _vm._v("\n                    Hvor gode er vi til at registrere tid?\n                ")], 1), _vm._v(" "), (_vm.data && !_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }, [(_vm.data) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.employees,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'available_hours') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("number")(props.row.available_hours)) + "\n                            ")]) : (props.column.field == 'logged_hours') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("number")(props.row.logged_hours)) + "\n                            ")]) : (props.column.field == 'full_name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.full_name
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.full_name) + "\n                            ")]) : (props.column.field == 'weekly_hours_working') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.weekly_hours_working) + "\n                            ")]) : (props.column.field == 'avg_per_week') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("number")(props.row.avg_per_week)) + "\n                            ")]) : (props.column.field == 'efficiency') ? _c('div', {
          staticClass: "coverage-cell",
          staticStyle: {
            "text-align": "left"
          }
        }, [_c('span', [_vm._v("\n                                    " + _vm._s(_vm._f("rounded")(props.row.efficiency)) + "\n                                    "), (props.row.efficiency) ? _c('span', [_vm._v("%")]) : _vm._e()]), _vm._v(" "), (props.row.efficiency) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.efficiency < _vm.$store.state.config.companyMeta.settings.timelogging.medium.value, 'avg': _vm.$options.filters.rounded(props.row.efficiency) >= _vm.$store.state.config.companyMeta.settings.timelogging.medium.value, 'good': _vm.$options.filters.rounded(props.row.efficiency) >= _vm.$store.state.config.companyMeta.settings.timelogging.high.value
          }
        }) : _vm._e()]) : _c('div', [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 3014051959)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _vm._e()], 1) : (!_vm.data && !_vm.loading) ? _c('div', {
    staticClass: "placeholder padding"
  }, [_vm._v("\n                    Vi kunne ikke hente data. Tjek, at du har angivet hvilke svende, der skal baseres data på under indstillinger.\n                ")]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v("\n            OBS! Der vises kun medarbejdere, som har registreret tid i den valgte periode.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    Opsummering\n                ")]), _vm._v(" "), (_vm.data && !_vm.loading) ? _c('div', {
    staticClass: "placeholder padding"
  }, [_c('div', {
    staticClass: "highlight"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Timer til rådighed\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("number")(_vm.data.totals.available_hours)) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "highlight"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Timer registreret\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("number")(_vm.data.totals.logged_hours)) + "\n                        ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "highlights",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "value",
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [(_vm.data.totals.efficiency) ? _c('div', {
    staticClass: "coverage-indicator",
    class: {
      'bad': _vm.data.totals.efficiency < _vm.$store.state.config.companyMeta.settings.timelogging.medium.value, 'avg': _vm.$options.filters.rounded(_vm.data.totals.efficiency) >= _vm.$store.state.config.companyMeta.settings.timelogging.medium.value, 'good': _vm.$options.filters.rounded(_vm.data.totals.efficiency) >= _vm.$store.state.config.companyMeta.settings.timelogging.high.value
    }
  }) : _vm._e(), _vm._v("\n                            " + _vm._s(_vm._f("rounded")(_vm.data.totals.efficiency)) + " %\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Af timer til rådighed er registreret\n                        ")])])]) : (!_vm.data && !_vm.loading) ? _c('div', {
    staticClass: "placeholder padding"
  }, [_vm._v("\n                    Vi kunne ikke hente data. Tjek, at du har angivet hvilke svende, der skal baseres data på under indstillinger.\n                ")]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70ce8938"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/employees/learning/timeUsageSkills.vue
// module id = 896
// module chunks = 0